// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"To-z","breadcrumbForward":"Uo-z","breadcrumbBack":"Vo-z","selected":"Wo-z"};